import { User } from "@/modules/user/types/user";
import { apiWithAuth } from "../authApi";

export const getUser = async (): Promise<User | undefined> => {
  try {
    const response = await apiWithAuth.get("/user/me");

    const answer = response.data.user as User;

    return answer;
  } catch (error) {
    return undefined;
  }
};
